import { Clock3 } from "lucide-react";
import type { Section } from "@/lib/sections";

export function PlaceholderSectionCard({ section }: { section: Section }) {
  const Icon = section.icon;
  return (
    <div className="fade-up grid gap-6 lg:grid-cols-[1.4fr_1fr]" style={{ animationDelay: "120ms" }}>
      <div className="rounded-2xl border border-slate-200/90 bg-white p-6 shadow-sm sm:p-10" data-testid="stage-placeholder-card">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-amber-200/80 bg-amber-50 px-3.5 py-1.5 text-xs font-semibold text-[#16294D]" data-testid="stage-placeholder-badge">
          <Clock3 className="h-3.5 w-3.5" /> Disponible en siguiente etapa
        </span>
        <div className="flex items-start gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#1B2A4A] text-amber-400">
            <Icon className="h-6 w-6" />
          </span>
          <div>
            <h2 className="font-display text-lg font-bold text-slate-900">{section.title} se está construyendo</h2>
            <p className="mt-1 text-sm text-slate-500">Esta vista se habilitará en la siguiente etapa del proyecto.</p>
          </div>
        </div>
        <div className="mt-8 grid gap-3 sm:grid-cols-3">
          {[0, 1, 2].map((i) => (
            <div key={i} className="h-20 rounded-xl border border-dashed border-slate-200 bg-slate-50/70" />
          ))}
        </div>
      </div>
      <div className="rounded-2xl border border-slate-200/90 bg-white p-6 shadow-sm sm:p-8">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-400">Lo que viene</p>
        <ul className="mt-4 space-y-3" data-testid="stage-placeholder-upcoming">
          {section.upcoming.map((item) => (
            <li key={item} className="flex items-start gap-3 text-sm text-slate-700">
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-amber-500" />
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
